if (typeof PrintcardExternalBuy !== 'function') {
  class PrintcardExternalBuy extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-js-printcard-external-buy]');
      this.variantOptions = this.querySelectorAll('[data-js-printcard-option]');
      this.originalProductVariants = document.querySelector('[data-main-product-page-variants]');
      this.originalProductData = document.querySelector('[data-js-product-data]');
      this.printcardProductData = document.querySelector('[data-js-product-printcard-data]');

      if (this.button) {
        this.button.addEventListener('click', this.onClickHandler.bind(this));
      }

      // Listen for variant changes in the original product
      if (this.originalProductVariants) {
        this.originalProductVariants.addEventListener('VARIANT_CHANGE', this.onOriginalVariantChange.bind(this));
      }
    }

    onOriginalVariantChange(e) {
      // Get the current variant from the original product
      const currentVariant = this.originalProductVariants.querySelector(
        '[data-update-block="variant-data-main-product"]'
      );
      if (!currentVariant) return;

      const variantData = JSON.parse(currentVariant.textContent);
      const productData = JSON.parse(this.originalProductData.textContent);

      console.log(variantData);
      console.log(productData);
      // Update printcard variant options to match original product
      this.variantOptions.forEach((selectOption) => {
        const optionName = selectOption.dataset.originalOptionName;
        if (!optionName) {
          console.warn('PrintcardExternalBuy: Missing originalOptionName data attribute on option:', option);
          return;
        }
        console.log('optionName', optionName);
        console.log('productData.options', productData.options);
        const optionIndex = productData.options.findIndex((opt) => opt === optionName);
        console.log('optionIndex', optionIndex);
        const matchingOption = variantData.options[optionIndex];
        console.log('matchingOption', matchingOption);

        if (matchingOption) {
          console.log('selectOption', selectOption);
          selectOption.value = matchingOption;
          selectOption.dispatchEvent(new Event('change'));
        } else {
          console.warn('PrintcardExternalBuy: Could not find matching option for:', optionName);
        }
      });
    }

    onClickHandler(e) {
      e.preventDefault();

      const button = e.currentTarget;
      const printcardProductId = button.dataset.printcardProductId;
      const currentVariantId = document.querySelector(
        '[data-update-block="variant-id-main-product"] input[name="_printcard_original_product_variant_id"]'
      ).value;
      const productData = JSON.parse(this.originalProductData.textContent);

      if (!printcardProductId || !currentVariantId) {
        console.error('Missing required data for printcard external buy');
        return;
      }

      // Get the current variant from the original product
      const currentVariant = this.originalProductVariants.querySelector(
        '[data-update-block="variant-data-main-product"]'
      );
      if (!currentVariant) return;

      const variantData = JSON.parse(currentVariant.textContent);

      // Get selected variant options
      const selectedOptions = {};
      this.variantOptions.forEach((selectOption) => {
        selectedOptions[selectOption.dataset.originalOptionName] = selectOption.value;
      });

      const printcardProductData = JSON.parse(this.printcardProductData.textContent);
      const selectedPrintcardVariant = printcardProductData.variants.find((variant) =>
        variant.options.every((option, index) => option === selectedOptions[printcardProductData.options[index]])
      );
      const originalProductVariantQuantity = document.querySelector(
        '[data-update-block="variant-id-main-product"] input[name="original_product_variant_quantity"]'
      ).value;
      button.classList.add('working');

      const body = {
        items: [
          {
            id: parseInt(selectedPrintcardVariant.id),
            quantity: originalProductVariantQuantity || 1,
            properties: {
              _printcard_original_product_product_id: productData.id,
              _printcard_original_product_product_title: productData.title,
              _printcard_original_product_variant_id: currentVariantId,
              _printcard_original_product_variant_title: variantData.title,
              _printcard_product: '1',
              _printcard_original_product_handle: productData.handle,
            },
            options: selectedOptions,
          },
        ],
      };

      fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status === 422) {
            const alert = document.createElement('span');
            alert.className = 'alert alert--error';
            alert.innerHTML = response.description || response.message;
            button.parentElement.prepend(alert);
            return;
          }
          window.location.href = KROWN.settings.routes.cart_url;
        })
        .catch((error) => {
          console.error('Error adding printcard to cart:', error);
          const alert = document.createElement('span');
          alert.className = 'alert alert--error';
          alert.textContent = KROWN.settings.locales.cart_general_error;
          button.parentElement.prepend(alert);
        })
        .finally(() => {
          button.classList.remove('working');
        });
    }
  }

  if (typeof customElements.get('printcard-external-buy') === 'undefined') {
    customElements.define('printcard-external-buy', PrintcardExternalBuy);
  }
}
